import request from '../../../lib/helpers/requestApi';
import { ContractsList, ContractsListParams } from './types';

export const getContractsListAPI = request<ContractsList, ContractsListParams>({
  method: 'contract.getList',
});
